import { Provider } from '@angular/core';
import {
  CreateOrUpdateSectorTaskGroupingUseCase,
  DeleteSectorTaskGroupingUseCase,
  RemoveTaskFromTaskGroupUseCase,
} from '@app/application/use-cases/sector-task-grouping';
import { SectorTaskGroupingRepository } from '@app/domain';
import { SectorTaskGroupingRepositoryImpl } from '../repositories';

export const SECTOR_TASK_GROUPING_PROVIDERS: Provider[] = [
  //Repositories
  {
    provide: SectorTaskGroupingRepository,
    useClass: SectorTaskGroupingRepositoryImpl,
  },
  {
    provide: CreateOrUpdateSectorTaskGroupingUseCase,
    useFactory: (sectorTaskGroupingRepo: SectorTaskGroupingRepository) =>
      new CreateOrUpdateSectorTaskGroupingUseCase(sectorTaskGroupingRepo),
    deps: [SectorTaskGroupingRepository],
  },
  {
    provide: DeleteSectorTaskGroupingUseCase,
    useFactory: (sectorTaskGroupingRepo: SectorTaskGroupingRepository) =>
      new DeleteSectorTaskGroupingUseCase(sectorTaskGroupingRepo),
    deps: [SectorTaskGroupingRepository],
  },
  {
    provide: RemoveTaskFromTaskGroupUseCase,
    useFactory: (sectorTaskGroupingRepo: SectorTaskGroupingRepository) =>
      new RemoveTaskFromTaskGroupUseCase(sectorTaskGroupingRepo),
    deps: [SectorTaskGroupingRepository],
  },
];
